import { createElementIdSlice } from '../utils/action/createElementSlice';
export const CrosstabState = createElementIdSlice({
    elementName: 'crosstab',
    initialState: {},
    reducers: {},
});
